export const subscriptionPrices = {
  advisor: import.meta.env.VITE_REACT_ADVISOR_PRICE || '$99.99/mo',
  analyst: import.meta.env.VITE_REACT_ANALYST_PRICE || '$99.99/mo',
  enterprise: (companySize?: string | null): string => {
    switch (companySize) {
      case '1-10': return import.meta.env.VITE_REACT_ENT_1_10_PRICE || '$499.99/mo';
      case '11-50': return import.meta.env.VITE_REACT_ENT_11_50_PRICE || '$1,499.99/mo';
      case '51-200': return import.meta.env.VITE_REACT_ENT_51_200_PRICE || '$2,499.99/mo';
      case '201-1000': return import.meta.env.VITE_REACT_ENT_201_1000_PRICE || '$4,999.99/mo';
      default: return 'Custom';
    }
  },
  getPlanPrice: (plan: string, companySize?: string | null): string => {
    if (plan === 'ADVISOR') return subscriptionPrices.advisor;
    if (plan === 'ANALYST') return subscriptionPrices.analyst;
    if (plan === 'ENTERPRISE') return subscriptionPrices.enterprise(companySize);
    return 'Custom';
  },
};
